var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import sort, { stringSort_depricated } from "@domains/utils/sort";
import { AIF_PMS, AIF_PMS_APPLY_SORT, AIF_PMS_CLEAR_MSG, AIF_PMS_CLEAR_SEARCH_DATA, AIF_PMS_CLEAR_SORT, AIF_PMS_ERROR, AIF_PMS_HIDE_ERROR, AIF_PMS_START_LOADER, AIF_PMS_STOP_LOADER, AIF_PMS_TABLE_START_LOADER, AIF_PMS_TABLE_STOP_LOADER, AIF_PMS_UPDATE, AIF_PMS_UPDATE_MSG, AIF_PMS_UPDATE_SEARCH_DATA, IF_PMS_VALIDATE_FORM_NUMBER, AIF_PMS_RECENT_CLIENT_SEARCH_DATA, AIF_PMS_PRODUCT_DETAILS_DATA, AIF_PMS_FILTER_DETAILS_DATA_AMC, AIF_PMS_FILTER_DETAILS_DATA_FUND, AIF_PMS_PARAMS, UPDATE_DRAFT_ORDER_COUNT, UPDATE_WATCHLIST_DATA, UPDATE_BOOKMARK_WATCHLIST, UPDATE_GET_DRAFT_ORDERS, UPDATE_DRAFT_ORDERS_DETAILS, UPDATE_SUB_CATEGORY_ID, UPDATE_CLIENT_DETAILS, UPDATE_TRANS_ID, AIF_PMS_PRODUCT_DOWNLOAD_DATA, CLICKED_FROM_DRAFT, AIF_PMS_FILTER_DETAILS_DATA_CATEGORY, AIF_PMS_ORDER_DATA, AIF_PMS_FILTER_LIST_DATA_FUND_NAME, AIF_PMS_FILTER_LIST_DATA_Benchmark, AIF_PMS_FILTER_LIST_DATA_Tenure, AIF_PMS_FILTER_LIST_DATA_AIF_FUND_NAME, UPDATE_COMMON_BANK_MASTER, AIF_PMS_FILTER_DETAILS_FUND_NAME, UPDATE_SUB_CATEGORY_PMS_ID, } from "../interface";
var initialState = {
    watchlist: [],
    paramsData: {},
    aifPmsLoader: false,
    aifPmsTableLoader: false,
    errorData: {
        error: null,
        isOpen: false,
    },
    message: {
        msg: "",
        show: false,
        icon: null,
    },
    searchState: {
        searchData: "",
    },
    sortData: {
        sortState: [],
        sortRecord: {},
    },
    updateData: [],
    totalPages: 1,
    validatFormNumber: "",
    recentClientSearchList: [],
    productDetails: {},
    filterDetailsAmc: [],
    filterDetailsFund: [],
    filterDetailsCategory: [],
    draftOrderCount: 0,
    draftOrderDeclarations: null,
    draftOrderDetails: null,
    watchListData: null,
    bookmarkWatchlist: [],
    draftOrderList: null,
    subCategoryId: 0,
    clientDetails: null,
    transactionId: 0,
    downloadProductFile: "",
    multiBookmark: null,
    clickedFromDraft: false,
    orderData: undefined,
    filterListFundName: [],
    filterListBenchmark: [],
    filterListTenure: [],
    filterListAIFFundName: [],
    commonBankMaster: null,
    filterDetailsFundName: [],
    subCategoryPmsId: 0,
};
var applySorting = function (sortRecord, data, sortData) {
    if (sortRecord.type && sortRecord.type === "string") {
        data = stringSort_depricated(data, sortRecord.key, sortRecord.order);
    }
    else {
        data = sort(data, sortRecord.key, sortRecord.order);
    }
    return { sortState: sortData, sortRecord: sortRecord, data: data };
};
var aifPms = function (state, action) {
    var _a, _b, _c, _d, _e, _f;
    if (state === void 0) { state = initialState; }
    switch (action.type) {
        case AIF_PMS:
            return __assign(__assign({}, state), { aifPmsWatchList: action.payload.aifPms, totalPages: action.payload.totalPages });
        case AIF_PMS_FILTER_DETAILS_DATA_FUND:
            return __assign(__assign({}, state), { filterDetailsFund: action.payload.filterDetailsFund });
        case AIF_PMS_ORDER_DATA:
            return __assign(__assign({}, state), { orderData: action.payload });
        case AIF_PMS_FILTER_DETAILS_DATA_AMC:
            return __assign(__assign({}, state), { filterDetailsAmc: action.payload.filterDetailsAmc });
        case AIF_PMS_FILTER_DETAILS_DATA_CATEGORY:
            return __assign(__assign({}, state), { filterDetailsCategory: action.payload.filterDetailsCategory });
        case AIF_PMS_FILTER_LIST_DATA_FUND_NAME:
            return __assign(__assign({}, state), { filterListFundName: action.payload.filterListFundName });
        case AIF_PMS_FILTER_LIST_DATA_AIF_FUND_NAME:
            return __assign(__assign({}, state), { filterListAIFFundName: action.payload.filterListAIFFundName });
        case AIF_PMS_FILTER_DETAILS_FUND_NAME:
            return __assign(__assign({}, state), { filterDetailsFundName: action.payload.filterDetailsFundName });
        case AIF_PMS_FILTER_LIST_DATA_Benchmark:
            return __assign(__assign({}, state), { filterListBenchmark: action.payload.filterListBenchmark });
        case AIF_PMS_FILTER_LIST_DATA_Tenure:
            return __assign(__assign({}, state), { filterListTenure: action.payload.filterListTenure });
        case AIF_PMS_PRODUCT_DOWNLOAD_DATA:
            return __assign(__assign({}, state), { downloadProductFile: action.payload.downloadProductFile });
        case AIF_PMS_PRODUCT_DETAILS_DATA:
            return __assign(__assign({}, state), { productDetails: action.payload.productDetails });
        case IF_PMS_VALIDATE_FORM_NUMBER:
            return __assign(__assign({}, state), { validateFormNumber: action.payload.validateFormNumber });
        case AIF_PMS_UPDATE:
            return __assign(__assign({}, state), { watchlist: action.payload.watchlist, totalPages: action.payload.totalPages });
        case AIF_PMS_RECENT_CLIENT_SEARCH_DATA:
            return __assign(__assign({}, state), { recentClientSearchList: __spreadArray(__spreadArray([], __read(state.recentClientSearchList), false), __read(action.payload.recentClientSearchList), false) });
        case AIF_PMS_ERROR:
            return __assign(__assign({}, state), { errorData: action.payload.errorData });
        case AIF_PMS_HIDE_ERROR:
            return __assign(__assign({}, state), { errorData: initialState.errorData });
        case AIF_PMS_PARAMS:
            return __assign(__assign({}, state), { paramsData: (_a = action === null || action === void 0 ? void 0 : action.payload) === null || _a === void 0 ? void 0 : _a.paramsData });
        case AIF_PMS_APPLY_SORT:
            return __assign(__assign({}, state), { sortData: {
                    sortRecord: (_b = action.payload) === null || _b === void 0 ? void 0 : _b.sortState.sortRecord,
                    sortState: (_c = action.payload) === null || _c === void 0 ? void 0 : _c.sortState.sortState,
                }, updateData: applySorting((_d = action.payload) === null || _d === void 0 ? void 0 : _d.sortState.sortRecord, (_e = action.payload) === null || _e === void 0 ? void 0 : _e.updatedData, (_f = action.payload) === null || _f === void 0 ? void 0 : _f.sortState.sortState).data });
        case AIF_PMS_CLEAR_SORT:
            return __assign(__assign({}, state), { sortData: initialState.sortData, updateData: initialState.updateData });
        case AIF_PMS_UPDATE_SEARCH_DATA:
            return __assign(__assign({}, state), { searchState: action.payload.searchState, updateData: action.payload.updatedData });
        case AIF_PMS_UPDATE_MSG:
            return __assign(__assign({}, state), { message: action.payload.message });
        case AIF_PMS_CLEAR_MSG:
            return __assign(__assign({}, state), { message: initialState.message });
        case AIF_PMS_CLEAR_SEARCH_DATA:
            return __assign(__assign({}, state), { searchState: initialState.searchState, updateData: initialState.updateData });
        case AIF_PMS_CLEAR_MSG:
            return __assign(__assign({}, state), { message: initialState.message });
        case AIF_PMS_START_LOADER:
            return __assign(__assign({}, state), { aifPmsLoader: true });
        case AIF_PMS_STOP_LOADER:
            return __assign(__assign({}, state), { aifPmsLoader: false });
        case AIF_PMS_TABLE_START_LOADER:
            return __assign(__assign({}, state), { aifPmsTableLoader: true });
        case AIF_PMS_TABLE_STOP_LOADER:
            return __assign(__assign({}, state), { aifPmsTableLoader: false });
        case UPDATE_DRAFT_ORDER_COUNT:
            return __assign(__assign({}, state), { draftOrderCount: action.payload.draftOrderCount });
        case UPDATE_WATCHLIST_DATA:
            return __assign(__assign({}, state), { watchListData: action.payload.watchListData });
        case UPDATE_BOOKMARK_WATCHLIST:
            return __assign(__assign({}, state), { bookmarkWatchlist: action.payload.bookmarkWatchlist });
        case UPDATE_DRAFT_ORDERS_DETAILS:
            return __assign(__assign({}, state), { draftOrderDetails: action.payload.draftOrderDetails });
        case UPDATE_GET_DRAFT_ORDERS:
            return __assign(__assign({}, state), { draftOrderList: action.payload.draftOrderList });
        case UPDATE_SUB_CATEGORY_ID:
            return __assign(__assign({}, state), { subCategoryId: action.payload.subCategoryId });
        case UPDATE_SUB_CATEGORY_PMS_ID:
            return __assign(__assign({}, state), { subCategoryPmsId: action.payload.subCategoryPmsId });
        case UPDATE_CLIENT_DETAILS:
            return __assign(__assign({}, state), { clientDetails: action.payload.clientDetails });
        case UPDATE_TRANS_ID:
            return __assign(__assign({}, state), { transactionId: action.payload.transactionId });
        case CLICKED_FROM_DRAFT:
            return __assign(__assign({}, state), { clickedFromDraft: action.payload.clickedFromDraft });
        case UPDATE_COMMON_BANK_MASTER:
            return __assign(__assign({}, state), { commonBankMaster: action.payload.commonbankMaster });
        default:
            return __assign({}, state);
    }
};
export default aifPms;
